import { Component, type ErrorInfo, type ReactNode } from 'react';
import { i18n } from '../i18n';
import { reportClientError } from '../lib/error-reporter';

/** Последний рубеж: при сбое рендера показывает понятный экран вместо белого листа и сообщает об ошибке. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    const e = new Error(error.message);
    e.name = error.name;
    e.stack = `${error.stack ?? ''}\nComponent stack:${info.componentStack ?? ''}`.slice(0, 8000);
    reportClientError(e, 'render');
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="crash-screen" role="alert">
        <h1>{i18n.t('errors.title')}</h1>
        <p className="muted">{i18n.t('errors.crashText')}</p>
        <button type="button" className="btn btn-primary btn-md" onClick={() => location.reload()}>
          {i18n.t('errors.reload')}
        </button>
      </div>
    );
  }
}
